/**
 * Created by Ivan on 07.07.2026
 */

const StickerView = function (sticker, options) {
    options = options || {};

    return Prefab.instantiate(bundles.sticker.jsons.sticker_prefab_json, {
        sticker,
        withUpdate: options.withUpdate,
        badge: options.badge,
        rewardContext: options.rewardContext
    });
};
